import React, { useState, useEffect } from 'react';
import api from '../../api'; // Adjust path if needed
import { useHistory } from 'react-router-dom';

const UserMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      history.push('/login');
      return;
    }

    const fetchMessages = async () => {
      try {
        const response = await api.get(`/customerMessage/user/${userId}`);
        setMessages(response.data);
      } catch (error) {
        console.error("Failed to fetch messages", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [history]);

  return (
    <div className="container" style={{ padding: '40px 20px', minHeight: '60vh' }}>
      <h2 style={{ marginBottom: '30px', fontFamily: 'serif', color: '#333' }}>My Messages</h2>
      
      {loading ? (
        <p>Loading messages...</p>
      ) : messages.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', background: '#f9f9f9', borderRadius: '10px' }}>
          <h3>No messages sent yet.</h3>
          <p>You can contact us from the <a href="/contact-us" style={{ color: '#FFC35B' }}>Contact Page</a>.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '20px' }}>
          {messages.map((msg) => (
            <div key={msg.id || msg.messageId} style={{ 
                background: '#fff', 
                padding: '20px', 
                borderRadius: '10px', 
                boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
                borderLeft: '5px solid #FFC35B'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontWeight: 'bold', color: '#555', textTransform: 'uppercase', fontSize: '14px' }}>
                  {msg.messageReason || "Inquiry"}
                </span>
                {/* If you have a date field, display it here. Assuming createdDate or similar */}
                {msg.createdDate && <span style={{ fontSize: '12px', color: '#999' }}>{new Date(msg.createdDate).toLocaleDateString()}</span>}
              </div>
              
              <p style={{ fontSize: '16px', color: '#333', lineHeight: '1.6' }}>
                {msg.customerMessage}
              </p>
              
              <div style={{ marginTop: '15px', paddingTop: '10px', borderTop: '1px solid #eee', fontSize: '13px', color: '#777' }}>
                Status: <span style={{ color: 'green', fontWeight: 'bold' }}>Sent to Admin</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserMessages;